// NOTE: Dependencies: jQuery

(function($) {
	$.fn.lmFilter = function(options) {
		
		// Was getting a bit annoyed with the weird way this was getting passed around before so just made it an unchanging const
		const $context = $(this);

		// Check is dom element is defined
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			$body: $('body'),
			$element: $('.filter'),
			filterCollapsed: 'filter__close--collapsed',
			sliderCollapsed: 'slider--collapsed',
			filterCheckBox: '.filter .product-item__checkbox',
			filterItems: '.filter__item',
			filterMoreOptions: '.filter__more-options',
			filterItemsHidden: '.filter__items-hidden',
			itemsToggle: 'filter__items-hidden--toggle',
			$loadMore: $('.compare-bar__load-more-btn'),
			loadMoreBtnClass: 'button--disabled',
			$loadMoreItems: $('#loadMoreItems'),
			$gridModeBtn: $('a[href="?gridMode=grid"]'),
			$listModeBtn: $('a[href="?gridMode=list"]'),
			gridMode : $('a[href="?gridMode=grid"]').length > 0 ? "grid" : null,
			clearAll: false,
			showAll: false,
			filterData: {
				page: 2,
				filters: [],
				categories: [],
				filterNames: {}
			},
			$productsHidden: $('#productsHidden'),
			$sliderWrapper: $('.filter .slider-wrapper'),
			$filterWrapper: $('.filter .filter-wrapper')
		}, options);

		// These are all the methods available for the plugin.
		var methods = {};

		methods.setCurrentSettings = function() {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
			settings.$filterReset = settings.$element.find('.filter__reset'),
			settings.$filterClose = settings.$element.find('.filter__close');
			settings.$filterSlider = settings.$element.find('div[data-slick]');
			settings.itemAjaxUrl = settings.$loadMoreItems.data('ajax-url');
			settings.filterAjaxUrl = settings.$element.data('ajax-url');
			settings.$filterCheckBox = $(settings.filterCheckBox);
			settings.$filterMoreOptions = $(settings.filterMoreOptions);
			settings.$filterItems = $(settings.filterItems);
		};

		methods.checkSlidePosition = function() {
			if (settings.$filterSlider.hasClass('slick-initialized')) {
				settings.activePosition = settings.$filterSlider.slick('slickCurrentSlide');
			} else {
				settings.activePosition = settings.$filterSlider.offset().left;
			}
		};

		methods.setFilterPosition = function() {
			setTimeout(function(){ 
				if (settings.$filterSlider.hasClass('slick-initialized')) {
					settings.$filterSlider.slick('slickGoTo', settings.activePosition);
				} else {
					settings.$filterSlider.scrollLeft(settings.activePosition);
				}
			}, 500);
		};

		// Bind events
		methods.events = function() {

			// On change of select checkbox
			//$(document).on( 'change.lmFilter', settings.filterCheckBox, function(event) {
			settings.$filterCheckBox.on('change.lmFilter', function(event) {
				event.preventDefault();
				settings.filterData.page = 1;

				// Check slide position
				methods.checkSlidePosition();

				// Populating filters based on whats checked
				methods.populateFilters();
			});

			settings.$filterClose.on('click', function(event) {
				event.preventDefault();
				var $this = $(this);

				if ($this.hasClass(settings.filterCollapsed)) {
					$this.removeClass(settings.filterCollapsed);
					$this.text($this.data('close'));
					settings.$filterSlider.removeClass(settings.sliderCollapsed);
				} else {
					$this.addClass(settings.filterCollapsed);
					$this.text($this.data('open'));
					settings.$filterSlider.addClass(settings.sliderCollapsed);
				}						
			});		

			settings.$filterReset.on('click', function(event) {
				event.preventDefault();

				// Set checkbox to unchecked. Done via document for when ajax loading of filters starts.
				$(document).find(settings.filterCheckBox).prop('checked', false);

				// Closing all more options
				var $filterMoreOptions = $(settings.filterMoreOptions);
				$(settings.filterItemsHidden).removeClass(settings.itemsToggle);
				$filterMoreOptions.text(settings.$element.data('more'));
				$filterMoreOptions.removeClass('filter__more-options--toggle');

				// Emptying hidden inputs
				settings.$productsHidden.val('');

				if (settings.$filterSlider.hasClass('slick-initialized')) {
					
					// Sliding slick slider to left
					settings.$filterSlider.slick( 'slickGoTo', 0 );

				} else {
				
					// Sliding normal mobile/tablet slider to left
					settings.$filterSlider.closest('.slider-wrapper').animate({
						scrollLeft: 0
					}, 500, 'swing');
				}

				settings.activePosition = 0;
				settings.filterData.page = 1;

				// Make ajax call
				methods.populateFilters();

			});

			settings.$loadMore.on('click.lmFilter', function(event) {
				event.preventDefault();

				// Load New data if button isn't disabled
				if (!$(this).hasClass(settings.loadMoreBtnClass)) {
					settings.showAll = true;
					methods.loadItems();
				}
			});

			settings.$filterMoreOptions.on('click', function(event) {
				event.preventDefault();
				methods.loadMoreFilters($(event.target));
			});

			// Display mode click event
			settings.$listModeBtn.on('click', function(event) {
				event.preventDefault();
				$('form').children('div#loadMoreItems').find('div.grid__col.grid__col--12').each(function () {
					$(this).removeClass('grid__col--sm-6').removeClass('grid__col--lg-3').removeClass('grid--equal-heights');
				});

				settings.gridMode = "list";
				$('div.product-item').addClass('product-item--list');
				$(this).addClass('compare-bar__grid-link--active');
				settings.$gridModeBtn.removeClass('compare-bar__grid-link--active').removeClass('compare-bar__list-link--active');
			});
	
			settings.$gridModeBtn.on('click', function(event) {
				event.preventDefault();
				$('form').children('div#loadMoreItems').find('div.grid__col.grid__col--12').each(function () {
					$(this).addClass('grid__col--sm-6').addClass('grid__col--lg-3').addClass('grid--equal-heights');
				});

				settings.gridMode = "grid";
				$('div.product-item').removeClass('product-item--list');
				$(this).addClass('compare-bar__grid-link--active');
				settings.$listModeBtn.removeClass('compare-bar__grid-link--active').removeClass('compare-bar__list-link--active');
			});
		};

		methods.loadMoreFilters = function($this) {
			var $parent = $this.parent(),
				$itemsHidden = $parent.find(settings.filterItemsHidden);

			if ($itemsHidden.hasClass(settings.itemsToggle)) {
				$itemsHidden.removeClass(settings.itemsToggle);
				$this.text(settings.$element.data('more'));
				$this.removeClass('filter__more-options--toggle');
			} else {
				$itemsHidden.addClass(settings.itemsToggle);
				$this.text(settings.$element.data('less'));
				$this.addClass('filter__more-options--toggle');
			}
		};

		// Loop through and populate array based on what is checked
		methods.populateFilters = function() {
			
			// Clear filters
			$('.compare-bar__clear-all-btn').click();

			settings.clearAll = true;
			settings.filterData.filters = [];
			settings.filterData.categories = [];
			settings.filterData.filterNames = {};

			$(document).find(settings.filterCheckBox).each(function() {
				var $checkBox = $(this);

				if ($checkBox.is(':checked')) {
					
					// Add
					if (this.hasAttribute('data-id')) {
						settings.filterData.filters.push($checkBox.data('id'));
					}
					if (this.hasAttribute('data-category-id')) {
						settings.filterData.categories.push($checkBox.data('category-id'));
					}
					

					if (this.hasAttribute('data-filter-category-name') && this.hasAttribute('data-filter-name')) {
						var categoryName = $checkBox.data('filter-category-name');

						if(!settings.filterData.filterNames[categoryName]) {
							settings.filterData.filterNames[categoryName] = [];
						} 

						settings.filterData.filterNames[categoryName].push($checkBox.data('filter-name'));

					}
				}
			});

			// Based on the object generated above. Make the ajax calls.
			methods.reloadFilters();
			methods.loadItems();
		};

		methods.reloadFilters = function() {		
			// Copying filterData object to var
			var filterData = $.extend({}, settings.filterData);
			
			filterData.filters = JSON.stringify(filterData.filters).replace(/]|[[]/g, '').replace(/'/g, '').replace(/"/g, '');
			filterData.categories = JSON.stringify(filterData.categories).replace(/]|[[]/g, '').replace(/'/g, '').replace(/"/g, '');
			filterData.filterNames = JSON.stringify(filterData.filterNames).replace(/],/g,'&').replace(/]|[[]/g, '').replace(/[{}]/g, '').replace(/'/g, '').replace(/"/g, '').replace(/:/g,'=');

			// Manual manipulation of the ajax URL.
			settings.filterAjaxUrl = settings.filterAjaxUrl.replace('{filters}',filterData.filters).replace('{categories}',filterData.categories).replace('{page}',filterData.page).replace('{filternames}',filterData.filterNames);
			
			$.ajax({
				type: 'GET',
				dataType: 'html',
				url: settings.filterAjaxUrl,
				success: function(data) {

					// Clear HTML
					settings.$sliderWrapper.html('');
					settings.$filterWrapper.html('');

					// Insert Filter
					settings.$sliderWrapper.html(data);
					settings.$filterWrapper.html(data);

					// Reinitialise slider
					// All breakpoints and inits dealt in that function
					$('div[data-slick]').lmSlider();
					
					// Reinitialise accordion
					$('.accordion').data('initialized', false);
					$('.accordion').accordion();

					// Resetting ajax URL so manipulation can occur everytime.
					settings.filterAjaxUrl = settings.$element.data('ajax-url');

					// Reset filter checkboxes. And rebind click event.
					settings.$filterCheckBox = $(settings.filterCheckBox);
					settings.$filterMoreOptions = $(settings.filterMoreOptions);
					settings.$filterSlider = settings.$element.find('div[data-slick]');

					settings.$filterCheckBox.on('click', function(e) {
						//do something if filter isn´t disabled
						if ($(this)[0].parentElement.className != "filter__item filter__item--disabled") {
							// Resetting to page one
							settings.filterData.page = 1;
													
							// Check slide position
							methods.checkSlidePosition();
							methods.populateFilters();
						} else {
							e.preventDefault();
						}						
					});

					settings.$filterMoreOptions.on('click', function(event) {
						event.preventDefault();
						methods.loadMoreFilters($(event.target));
					});

					// Move to position before filters were clicked.
					methods.setFilterPosition();

					// Resetting ajax URL so manipulation can occur everytime.
					settings.filterAjaxUrl = settings.$element.data('ajax-url');

					methods.loadItems();
				}
			});			
		};

		methods.loadItems = function() {
			settings.$loadMoreItems.addClass('loading');

			// Add disabled class
			settings.$loadMore.addClass(settings.loadMoreBtnClass);
			settings.$filterItems.addClass('filter__item--disabled');
			
			// Copying filterData object to var
			var filterData = $.extend({}, settings.filterData);
			
			filterData.filters = JSON.stringify(filterData.filters).replace(/]|[[]/g, '').replace(/'/g, '').replace(/"/g, '');
			filterData.categories = JSON.stringify(filterData.categories).replace(/]|[[]/g, '').replace(/'/g, '').replace(/"/g, '');
			filterData.filterNames = JSON.stringify(filterData.filterNames).replace(/],/g,'&').replace(/]|[[]/g, '').replace(/[{}]/g, '').replace(/'/g, '').replace(/"/g, '').replace(/:/g,'=');

			if(settings.showAll){
				filterData.page = -1;
			}

			// Manual manipulation of the ajax URL.
			settings.itemAjaxUrl = settings.itemAjaxUrl.replace('{filters}',filterData.filters).replace('{categories}',filterData.categories).replace('{page}',filterData.page).replace('{filternames}',filterData.filterNames);
			$.ajax({
				type: 'GET',
				dataType: 'html',
				url: settings.itemAjaxUrl,
				success: function(data) {

					// On success 
					var $html = $(data),
						$firstItem = $html.filter('.grid__col').first().find('.product-item'),
						pageCountCurrent = $firstItem.data('pagecount-current'),
						pageCountTotal = $firstItem.data('pagecount-total');

					settings.filterData.page = pageCountCurrent + 1;

					// change classes depending on dispaly mode
					if (settings.gridMode != null) {
						if (settings.gridMode == "list") {
							$html.filter('.grid__col').each(function(){
								$(this).removeClass('grid__col--sm-6').removeClass('grid__col--lg-3').removeClass('grid--equal-heights');
								$(this).find('.product-item').addClass('product-item--list');
							});
						
						} 
						
						if (settings.gridMode == "grid") {
							$html.filter('.grid__col').addClass('grid__col--sm-6').addClass('grid__col--lg-3').addClass('grid--equal-heights');
							$html.filter('.grid__col').find('.product-item').removeClass('product-item--list');;
						}
					}

					data = $html;

					// Reinitialise product-item
					data.filter('.grid__col').find('.product-item').lmProductItem();

					// If filter action not load more, clear all.
					if (settings.clearAll) {
						settings.$loadMoreItems.html('');
					}

					// Remove disabled class if not last page
					if (!settings.showAll){
						if (pageCountCurrent != pageCountTotal) {
							settings.$loadMore.removeClass(settings.loadMoreBtnClass);
						}
					}					

					// Append data
					settings.$loadMoreItems[0].innerHTML = '';
					settings.$loadMoreItems.append(data);
					settings.clearAll = false;					

					// Resetting ajax URL so manipulation can occur everytime.
					settings.itemAjaxUrl = settings.$loadMoreItems.data('ajax-url');

					settings.$loadMoreItems.removeClass('loading');
					settings.$filterItems.removeClass('filter__item--disabled');
				}
			});
		};

		methods.initContext = function() {
			methods.setCurrentSettings();
		};

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data('initialized');
		};

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			
			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext();

			// Run once methods when jquery plugin is called.
			methods.events(this);
		});
	};

	if ($('body').length) {
		$('body').lmFilter();
	}

}(jQuery));
